// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  orgId: __t.u64().name("org_id"),
  provider: __t.string(),
  keyCiphertext: __t.string().name("key_ciphertext"),
  keyLast4: __t.string().name("key_last_4"),
  updatedAt: __t.i64().name("updated_at"),
});
